import BillOfMaterialDetail from '@/models/BillOfMaterial/BillOfMaterialDetail';

export default class BillOfMaterialDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.billOfMaterialId  = '';
		this.billOfMaterialPartNumber = '';
		this.id = '';
		this.partNumberId  = '';
		this.partNumberPartNumber = '';
		this.partName = '';
		this.usedQty = '';
		this.uom = '';
		this.partPriceId  = '';
		this.partPricePart = '';
		this.priceProduct = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			billOfMaterialId : '0',
			billOfMaterialPartNumber : '0',
			id : '0',
			partNumberId : '0',
			partNumberPartNumber : '0',
			partName : '0',
			usedQty : '0',
			uom : '0',
			partPriceId : '0',
			partPricePart : '0',
			priceProduct : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}